// import "lazysizes/plugins/bgset/ls.bgset";
// import "lazysizes/plugins/parent-fit/ls.parent-fit";

import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { MediaQueryPublisher } from "./media.query.publisher.class";

const currentBP = MediaQueryPublisher.currentBreakpoint();

$(function() {
  $(".hero-spin__main__content__container").each(function() {
    new CSSBackgroundImage(this, MediaQueryPublisher);
  });
});

const CSSBackgroundImageOptions = {
  readyBP: currentBP
};
class CSSBackgroundImage extends Class {
  constructor(element, mqp, options) {
    super();
    this.element = $(element);
    this.setOptions(CSSBackgroundImageOptions, options);
    this.mqp = mqp;
    this.setupEvents();
    this.getBgImage(this.options.readyBP);
  }

  setupEvents() {
    var self = this;
    $(this.mqp).on("abacus:newBreakpoint", function(e, breakpoint) {
      self.options.readyBP = MediaQueryPublisher.currentBreakpoint();
      self.getBgImage(self.options.readyBP);
    });
  }

  splitArrayAndReturnDescriptor(arr) {
    let itemString = arr.trim(), itemArr = itemString.split(" ");
    if(itemString.indexOf(" ")==-1) return "none";
    return itemArr[1].slice(0, -1);
  }

  getBgImage() {
    let source = [...this.element.data("bgset").split(",")].filter(item => {
      let itemImgWidthDescriptor = this.splitArrayAndReturnDescriptor(item);
      if (this.options.readyBP == "mobile" && itemImgWidthDescriptor == "320")
        return item;
      if (
        this.options.readyBP == "mobile-landscape" &&
        itemImgWidthDescriptor == "768"
      )
        return item;
      if (
        this.options.readyBP == "tablet-portrait" &&
        itemImgWidthDescriptor == "768"
      )
        return item;
      if (
        this.options.readyBP == "tablet-landscape" &&
        itemImgWidthDescriptor == "1024"
      )
        return item;
      if (this.options.readyBP == "desktop" && itemImgWidthDescriptor == "1280")
        return item;
      if(itemImgWidthDescriptor == "none"){
        return item;
      }
    }, this);

    this.setBgImage(source);
  }

  setBgImage(imageArr) {
    let itemArr = new String(imageArr).split(" ");
    this.element[0].style.backgroundImage = `url(${itemArr[0]})`;
  }
}

const mql = window.matchMedia("screen and (min-width: 767px)"),
  heroSpin = [...document.querySelectorAll(".hero-spin")];

var observer = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.intersectionRatio > 0) {
      $(entry.target)
        .parents(".hero-spin")
        .addClass("animated");
      observer.unobserve(entry.target);
    }
  });
});

let focusObserve = (element,anchor,tabin) => {
  element.forEach(hero => {
    $(hero).find(anchor).attr("tabindex",tabin);
  
    // observe only those which have more than one story
    observer.observe(hero.querySelector(".hero-spin__main__content"));
    $(hero)
      .parents(".spinBlock")
      .addClass("has-hero-spin");
  });
}
if (mql.matches && heroSpin) {
   focusObserve(heroSpin, '.hero-spin__main__storytype a', '-1');
}else{
    heroSpin.forEach(hero => {
      focusObserve(heroSpin, '.hero-spin__main__content__storytype a', '-1');
  });
}



// WEBPACK FOOTER //
// ./Javascript/core/classes/spin-hero.js